import React from 'react';
import { ToolbarItemConfig } from '../toolbarTypes';

const EmptyTool = () => <div />;

const ToolbarItemsList = ({ items, ...rest }: { items: ToolbarItemConfig[] }): React.ReactElement => {
    return (
        <>
            {items.map((item) => {
                const Component = item.component || EmptyTool;

                return (
                    <Component {...rest} {...item} id={undefined} key={item.id} item={item}>
                        {/* ensure any passed "children" prop is nulled out */}
                        {undefined}
                    </Component>
                );
            })}
        </>
    );
};

export default ToolbarItemsList;
